import { Nav } from "react-bootstrap";
import { BsGlobe } from "react-icons/bs";

export const AlignUIRender = (props: any) => {

  return (
    <div id="unAuthContent">

      <a className="logo" href="https://alignbsystems.com/" target="__blank">
        <img src={require("@/Assets/Images/logo-dark.png").default} alt="" />
      </a>
      <div className="form-container">
        <div className="text">
          <h6>Sign In</h6>
          <span>Hey, Enter your credentials to sign in to your account</span>
        </div>
        <div className="form">
          {props.children}
        </div>
      </div>
      <div className="form-links">
        <a href="https://PeopleNest.com/" target="__blank">PeopleNest</a>
        <a href="https://alignbsystems.com/about-us" target="__blank">About</a>
        <a className="fw-bold" href="https://peoplenest.ai/" target="__blank">PeopleNest.Ai</a>
        <a href="https://alignbsystems.com/careers" target="__blank">Careers</a>
        <a href="https://alignbsystems.com/contact-us" target="__blank">Contact Us</a>
      </div>

    </div>
  )
};
